import React from "react";
import { Moon, SunMedium } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

const labelByTheme = {
  dark: "Switch to light mode",
  light: "Switch to dark mode",
};

export default function ThemeToggle({ className = "" }) {
  const { isDark, theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={labelByTheme[theme]}
      title={labelByTheme[theme]}
      className={`theme-toggle ${className}`.trim()}
    >
      {isDark ? <SunMedium className="h-3.5 w-3.5" /> : <Moon className="h-3.5 w-3.5" />}
    </button>
  );
}
